import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useMarketAnalysisPosts } from '../../../../hooks/useMarketAnalysisPosts';
import './FromTheBlog.css';

const ArrowUpRight = () => (
  <svg
    className="from-the-blog__arrow"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7 17L17 7M17 7H9M17 7V15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FromTheBlog = ({ currentSlug }) => {
  const { posts, isLoading } = useMarketAnalysisPosts();

  if (isLoading) {
    return null;
  }

  const relatedPosts = posts
    .filter((post) => post.slug !== currentSlug)
    .slice(0, 4);

  return (
    <section className="from-the-blog">
      <div className="from-the-blog__inner">
        <Reveal className="from-the-blog__header">
          <h2 className="from-the-blog__title">From the blog</h2>
          <p className="from-the-blog__text">
            The latest industry news, interviews, technologies, and resources.
          </p>
        </Reveal>

        <div className="from-the-blog__grid">
          {relatedPosts.map((post, index) => {
            const to = `/insights/market-analysis/${post.slug}`;

            return (
              <Reveal key={post.slug} delay={index * 60}>
                <article className="from-the-blog__card">
                  <Link to={to} className="from-the-blog__media">
                    <img
                      className="from-the-blog__image"
                      src={post.image}
                      alt=""
                    />
                  </Link>

                  <div className="from-the-blog__copy">
                    <p className="from-the-blog__tag">{post.category}</p>

                    <Link to={to} className="from-the-blog__title-link">
                      <h3 className="from-the-blog__card-title">{post.title}</h3>
                      <ArrowUpRight />
                    </Link>

                    <p className="from-the-blog__excerpt">{post.excerpt}</p>

                    <div className="from-the-blog__author">
                      <img
                        className="from-the-blog__avatar"
                        src={post.avatar}
                        alt=""
                        aria-hidden="true"
                      />
                      <div className="from-the-blog__author-meta">
                        <p className="from-the-blog__author-name">{post.author}</p>
                        <p className="from-the-blog__author-date">{post.date}</p>
                      </div>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>

        <div className="from-the-blog__footer">
          <Link
            to="/insights/market-analysis"
            className="from-the-blog__cta luxury-btn"
          >
            View all posts
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FromTheBlog;
